import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import Image from './_image.js'
import ImageButton from './_image-button.js'

export default {
  name: 'MarketInstructions',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          boxSizing: 'border-box',
          padding: '8px 0',
          _mobile_padding: '8px 8px 0px 8px',
        },
      },
    },
    contentContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          justifyContent: 'space-between',
        },
      },
    },
    mainSection: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexDirection: 'column',
          padding: '8px 0 8px 8px',
        },
      },
    },
    headerSection: {
      configSet: FlexPane,
      configValues: {},
    },
    title: {
      configSet: Text,
      configValues: {},
    },
    contentSection: {
      configSet: FlexPane,
      configValues: {},
    },
    contentText: {
      configSet: Text,
      configValues: {},
    },
    logoContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexGrow: '0',
          padding: '0 8px 0 0',
        },
      },
    },
    logo: {
      configSet: Image,
      configValues: {
        style: {
          width: '16px',
          height: '16px',
        },
      },
    },
    closeImgBtn: {
      configSet: ImageButton,
      configValues: {
        button: {
          style: {
            base: {
              alignItems: 'center',
              flexGrow: '0',
              width: '32px',
              height: '32px',
            },
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
